import {ProductVariantInterface} from "@/core/types";

export function propertyTraverser(path: string) {
  const steps = path.split('.');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return object => steps.reduce((obj, key) => obj && key in obj ? obj[key] : '', object);
}

// Pobierz wartość właściwości na podstawie tokenu
export function getter(token: string) {
  const isOptional = token.endsWith("?%");
  const getValue = propertyTraverser(token.replace(/%|\?/g, ''));
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return data => {
    const value = getValue(data);
    if (value != null) {
      return value;
    }
    if (isOptional) {
      return '';
    }
  };
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function replaceConditionMacros(generatedHtml, mainProduct) {
  
  // Obsługa instrukcji warunkowej if/else
  const ifRegex = /{{#if (\w+)\s*(===|!==|==|!=|>|>=|<|<=)?\s*(['"]?[\w\s]+['"]?)?}}([\s\S]+?){{\/if}}/g;
  
  let newHtml = generatedHtml;
  const matches = Array.from(newHtml.matchAll(ifRegex));
  
  matches.forEach(match => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    const [fullMatch, ifVariable, operator, compareValue, fullIfContent] = match;
    
    // Rozdzielamy zawartość na sekcje if i else
    const splitContent = fullIfContent.split('{{else}}');
    const ifContent = splitContent[0];
    const elseContent = splitContent[1] || '';
    
    let ifResult = '';
    
    // Usuwamy cudzysłowy jeśli są obecne
    const cleanedCompareValue = compareValue ? compareValue.replace(/['"]/g, '') : null;
    
    let conditionMet = false;
    
    switch (operator) {
      case '===':
        conditionMet = mainProduct[ifVariable] === cleanedCompareValue;
        break;
      case '!==':
        conditionMet = mainProduct[ifVariable] !== cleanedCompareValue;
        break;
      case '==':
        conditionMet = mainProduct[ifVariable] == cleanedCompareValue;
        break;
      case '!=':
        conditionMet = mainProduct[ifVariable] != cleanedCompareValue;
        break;
      case '>':
        conditionMet = mainProduct[ifVariable] > cleanedCompareValue;
        break;
      case '>=':
        conditionMet = mainProduct[ifVariable] >= cleanedCompareValue;
        break;
      case '<':
        conditionMet = mainProduct[ifVariable] < cleanedCompareValue;
        break;
      case '<=':
        conditionMet = mainProduct[ifVariable] <= cleanedCompareValue;
        break;
      default:
        conditionMet = Boolean(mainProduct[ifVariable]);
    }
    
    ifResult = conditionMet ? ifContent : elseContent;
    
    newHtml = newHtml.replace(fullMatch, ifResult);
  });
  
  return newHtml;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function replaceLoopMacros(generatedHtml: string, productVariants: any[], showLimit?: number) {
  const loopRegex = /{{\s*#each\s+(\w+)\s*}}([\s\S]+?){{\s*\/each\s*}}/g;
  
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const match = loopRegex.exec(generatedHtml);
    if (!match) {
      break;
    }
    
    const [fullMatch, loopVariable, loopContent] = match;
    
    let loopResult = '';
    if (loopVariable === 'variant') {
      const showRegex = /{{\s*#show\s+(\d+)\s+elements\s*}}([\s\S]+?){{\s*showRest\s*}}([\s\S]+?){{\s*\/show\s*}}/;
      const showMatch = showRegex.exec(loopContent);
      const showLimitFromContent = showMatch ? parseInt(showMatch[1], 10) : (showLimit ?? productVariants.length);
      const [firstPart, secondPart] = showMatch ? [showMatch[2], showMatch[3]] : [loopContent, ''];
      
      const lastPropertyValues: { [key: string]: string } = {};
      
      if (productVariants.length <= showLimitFromContent) {
        // If the number of product variants is less than or equal to the show limit, only process the first part
        productVariants.forEach((variant, index) => {
          let loopItem = firstPart;
          for (const variantProperty in variant) {
            const regex = new RegExp(`{{\\s*${variantProperty}\\s*}}`, 'g');
            const propertyValue = variant[variantProperty];
            
            if (lastPropertyValues[variantProperty] !== propertyValue) {
              loopItem = loopItem.replace(regex, propertyValue || '');
              lastPropertyValues[variantProperty] = propertyValue;
            } else {
              loopItem = loopItem.replace(regex, '');
            }
          }
          loopResult += loopItem;
        });
      } else {
        // If there are more product variants than the show limit, process both parts
        productVariants.forEach((variant, index) => {
          let loopItem = index < showLimitFromContent ? firstPart : '';
          for (const variantProperty in variant) {
            const regex = new RegExp(`{{\\s*${variantProperty}\\s*}}`, 'g');
            const propertyValue = variant[variantProperty];
            
            if (lastPropertyValues[variantProperty] !== propertyValue) {
              loopItem = loopItem.replace(regex, propertyValue || '');
              lastPropertyValues[variantProperty] = propertyValue;
            } else {
              loopItem = loopItem.replace(regex, '');
            }
          }
          loopResult += loopItem;
        });
        
        if (productVariants.length > showLimitFromContent) {
          let secondPartProcessed = secondPart;
          productVariants.forEach(variant => {
            for (const variantProperty in variant) {
              const regex = new RegExp(`{{\\s*${variantProperty}\\s*}}`, 'g');
              const propertyValue = variant[variantProperty];
              
              if (lastPropertyValues[variantProperty] !== propertyValue) {
                secondPartProcessed = secondPartProcessed.replace(regex, propertyValue || '');
                lastPropertyValues[variantProperty] = propertyValue;
              } else {
                secondPartProcessed = secondPartProcessed.replace(regex, '');
              }
            }
          });
          loopResult += secondPartProcessed;
        }
      }
    }
    
    generatedHtml = generatedHtml.replace(fullMatch, loopResult || '');
  }
  return generatedHtml;
}



// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function replaceMainMacros(generatedHtml, mainProduct) {
  for (const [key, value] of Object.entries(mainProduct)) {
    const regex = new RegExp(`{{${key}}}`, 'g');
    generatedHtml = generatedHtml.replace(regex, value || '');
  }
  
  return generatedHtml
}


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export function createTemplate(templateString, mainProduct, productVariants) {
  let generatedHtml = templateString;
  
  generatedHtml = replaceConditionMacros(generatedHtml, mainProduct,)
  const loopRegex = /{{\s*#each\s+(\w+)\s*}}([\s\S]+?){{\s*\/each\s*}}/g;
  const match = generatedHtml.match(loopRegex)
  if (match) {
    for (let i = 0; i < match.length; i++) {
      generatedHtml = replaceLoopMacros(generatedHtml, productVariants)
    }
  }
  
  generatedHtml = replaceLoopMacros(generatedHtml, productVariants)
  
  generatedHtml = replaceMainMacros(generatedHtml, mainProduct)
  
  return generatedHtml;
}


/**
 * Przykłady użycia
 * {{#if someVariable}}
 *   <p>Zmienna someVariable istnieje!</p>
 * {{/if}}
 *
 *
 * {{#if someVariable}}
 *   <p>Zmienna someVariable istnieje!</p>
 *   {{else}}
 *   <p>Zmienna someVariable nie istnieje!</p>
 * {{/if}}
 *
 *
 */


